import { createContext, useContext } from 'react';

/**
 * Слой открытого окна. `UDModal` рисуется нативным `<dialog>` через `showModal()`: всё, что
 * лежит вне него (списки, подсказки, тосты в `body`), — под окном и инертно. Компоненты кита,
 * которые выносят своё содержимое порталом, берут отсюда `dialog` и кладут содержимое в него.
 * Вне окна `dialog` — `null`.
 *
 * `setDirty` — форма внутри окна сообщает, что в ней есть правки (`UDModalDirtyGuard` из
 * `ud-form`). С правками окно не закрывается кликом вне, Escape и крестиком сразу, а спрашивает
 * «Бросить изменения?». Вне окна и в `Modal.Confirm` — ничего не делает.
 */
export interface ModalLayer {
  dialog: HTMLDialogElement | null;
  setDirty: (dirty: boolean) => void;
}

export const ignoreDirty: ModalLayer['setDirty'] = () => {};

/**
 * Класс белого окна (`ModalContainer`) и тела (`Modal.Body`) — двух панелей, которые
 * прокручивает кит. Список, вынесенный в `<dialog>`, закрывается при их прокрутке: поле
 * уезжает, а список остался бы висеть.
 */
export const MODAL_CONTAINER_CLASS = 'modal-container';
export const MODAL_BODY_CLASS = 'modal-body';

export const ModalLayerContext = createContext<ModalLayer>({ dialog: null, setDirty: ignoreDirty });

export function useModalLayer(): ModalLayer {
  return useContext(ModalLayerContext);
}
